import {
  Box,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Skeleton,
} from "@mui/material";
import {
  CategoryScale,
  Chart as ChartJS,
  defaults,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { default as jalaliMoment, default as moment } from "jalali-moment";
import React, { useEffect, useState } from "react";

import { Line } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import DateInput from "../../components/inputs/dateInput";
import PageTitle from "../../components/pageTitle";
import { API } from "../../scripts/api";
import axiosInstance from "../../scripts/axiosInspector";
import { toIsoString } from "../../scripts/functions";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);
defaults.font.family = "IRANSansfa";

const Home = () => {
  const currentDate = jalaliMoment();

  const { themeDisplay } = useSelector((state) => state.ThemeToggler);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const dispatch = useDispatch();
  const [allCompany, setAllCompany] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingChart, setLoadingChart] = useState(false);
  const [date, setDate] = useState({
    start: moment(currentDate.startOf("jMonth").format("YYYY/MM/DD")).format(),
    end: toIsoString(new Date()),
  });
  const [dataList, setDataList] = useState([]);
  const [chRepTypeCode, setChRepTypeCode] = useState("Accumulative");
  /*   useEffect(() => {
    if (userInfo) {
      setLoading(true);
      axiosInstance
        .get(API.user.permissions, {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          },
        })
        .then((res) => {
          setLoading(false);
          if (res?.data?.data?.length > 0) {
            setAllCompany(res?.data?.data);
            if (!company) {
              dispatch(
                handleCurrentCompanyAction(
                  res?.data?.data[res?.data?.data?.length - 1]
                )
              );
            }
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [userInfo]); */
  useEffect(() => {
    if (company?.guidRecNo && userInfo) {
      setLoadingChart(true);
      axiosInstance
        .get(
          API.rep.sellPurch +
            `?guidStateRecNo=${company?.guidRecNo}&dtFromDateTime=${toIsoString(
              new Date(date.start)
            )}&dtToDateTime=${date.end}&chRepTypeCode=${chRepTypeCode}`,
          {
            headers: {
              Authorization: `Bearer ${userInfo?.token}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "Accept-Language": "fa-IR",
              chHostName: process.env.REACT_APP_CHHOSTNAME,
            },
          }
        )
        .then((res) => {
          setDataList(res.data.data);
          setLoadingChart(false);
        })
        .catch((err) => {
          setLoadingChart(false);
          /*        if (err.response.status === 401 || err.response.status === 403) {
            dispatch(handleLogOut());
          } */
        });
    }
  }, [userInfo, company?.guidRecNo, date.start, date.end, chRepTypeCode]);
  /*   const handleChange = (event) => {
    dispatch(
      handleCurrentCompanyAction(
        allCompany?.find((item) => item?.guidRecNo === event.target.value)
      )
    );
    dispatch(resetAllStateAction());
  };
 */
  const dark = themeDisplay === "dark";
  return (
    <>
      <PageTitle />
      <Paper className="mx-3 min-h-[60vh] mt-6 border pb-10 bg-white z-[50] relative">
        {/*       <div className="grid md:grid-cols-4 grid-cols-1 p-4">
          {loading ? (
            <Skeleton
              width={"100%"}
              height={50}
              variant="rounded"
              animation="wave"
            />
          ) : (
            <FormControl>
              <InputLabel id="demo-simple-select-readonly-label">
                شرکت انتخاب شده
              </InputLabel>
              <Select
                labelId="demo-simple-select-readonly-label"
                id="demo-simple-select-readonly"
                value={company?.guidRecNo}
                label=" شرکت انتخاب شده"
                onChange={handleChange}
                inputProps={{ readOnly: allCompany?.length < 2 }}
              >
                {allCompany?.map((item, index) => (
                  <MenuItem value={item?.guidRecNo} key={item?.guidRecNo}>
                    {item?.chName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </div> */}
        <div className="">
          <Box className="w-full mainBg md:h-14 h-10 flex text-white justify-center items-center font-bold text-base">
            - خرید و فروش -
          </Box>
          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3 px-3">
            <DateInput
              label={"از تاریخ"}
              value={date.start}
              onChange={(e) => setDate({ ...date, start: e })}
            />
            <DateInput
              label={"تا تاریخ"}
              value={date.end}
              onChange={(e) => setDate({ ...date, end: e })}
            />{" "}
            <fieldset
              style={{ borderColor: "#0000003b" }}
              className="border h-[62px] md:-mt-[6px]  px-3  rounded-[4px] col-span-2 lg:col-span-1  "
            >
              <legend className="px-4 text-right text-xs ">
                {" "}
                محاسبه بر اساس
              </legend>
              <FormControl>
                <RadioGroup
                  aria-labelledby="chRepTypeCode"
                  name="chRepTypeCode"
                  row
                >
                  <FormControlLabel
                    onChange={(e) => {
                      setChRepTypeCode("Case");
                    }}
                    control={<Radio checked={chRepTypeCode === "Case"} />}
                    label=" موردی"
                  />
                  <FormControlLabel
                    onChange={(e) => {
                      setChRepTypeCode("Accumulative");
                    }}
                    control={
                      <Radio checked={chRepTypeCode === "Accumulative"} />
                    }
                    label=" تجمیعی"
                  />
                </RadioGroup>
              </FormControl>
            </fieldset>
          </div>{" "}
          <div className="mt-5 px-3 mx-auto md:max-w-2xl">
            {loadingChart ? (
              <>
                {" "}
                <Skeleton
                  width={"100%"}
                  height={250}
                  variant="rounded"
                  animation="wave"
                />
              </>
            ) : (
              <Line
                data={{
                  labels: dataList?.map((a) => a.chDate),
                  datasets: [
                    {
                      label: "مجموع مبلغ پس از کسر تخفیف فروش",
                      borderColor: "rgb(53, 162, 235)",
                      backgroundColor: "rgba(53, 162, 235, 0.5)",
                      borderWidth: 2,
                      data: dataList?.map(
                        (a) => a.moSumTotalPriceAfterDiscount_Sell
                      ),
                    },

                    {
                      label: "مجموع صورتحساب خرید",
                      borderColor: "rgb(255, 99, 132)",
                      backgroundColor: "rgba(255, 99, 132, 0.5)",
                      borderWidth: 2,
                      data: dataList?.map((a) => a.moSumTotalBillPrice_Purch),
                    },
                    {
                      label: "سود",
                      borderColor: "rgb(53, 235, 53)",
                      backgroundColor: "rgba(53, 235, 53, 0.5)",
                      borderWidth: 3,
                      data: dataList?.map((a) => a.moProfit),
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  interaction: {
                    mode: "index",
                    intersect: false,
                  },
                  stacked: false,
                  plugins: {
                    legend: {
                      position: "top",
                      labels: {
                        color: dark ? "#fff" : "#000",
                      },
                    },
                    title: {
                      display: false,
                      /*   text: `   ${months[time - 1]} ماه ${years}`, */
                      color: dark ? "#fff" : "#000",
                    },
                  },
                  scales: {
                    x: {
                      ticks: {
                        color: dark ? "#fff" : "#000",
                      },
                    },
                    y: {
                      type: "linear",
                      display: true,
                      position: "left",
                      ticks: {
                        beginAtZero: true,
                        precision: 0,
                        color: dark ? "#fff" : "#000",
                      },
                    },
                    y1: {
                      type: "linear",
                      display: false,
                      position: "right",
                      grid: {
                        drawOnChartArea: false,
                      },
                    },
                  },
                }}
              />
            )}
          </div>
        </div>
      </Paper>
    </>
  );
};

export default Home;
